import React, { FC } from 'react'
import Typography from 'Components/DesignSystem/Typography/Typography'
import CustomAttributeTag from 'Components/Common/CustomAttributeTag'

interface AttributeValue {
    val_id: string;
    value: string;
  }

  interface Attribute {
    attr_value: AttributeValue[];
  }

/**
 * Read-only attribute panel on DS Typography (§ 77). The legacy markup used an `h2`
 * for every attribute NAME — a heading level above the product name itself — so a
 * screen-reader outline read each label as a top-level section. Labels are `title`
 * tokens now; values keep the secondary ink.
 */
const Attributes: FC<Attribute> = ({attr_value}) => {
  return (
    <React.Fragment>
        <Typography variant="title-header" as="h3" className={`tw-mt-3 tw-ms-1 tw-text-ink`}>Attributes</Typography>

    <div className={`tw-flex tw-flex-wrap tw-justify-start`}>
            {attr_value?.map((attribute: any, index: number) => {
              let valuesArr = attribute.attr_value;
              let varr: any = [];
              valuesArr.forEach((valObj:any) =>
                varr.push(valObj.value)
              );
              return(
              <div key={index } style={{overflowWrap: "break-word"}} className={`tw-w-1/3 tw-p-1 tw-mt-3`}>
                <Typography variant="title" as="span" className="tw-flex tw-items-center tw-gap-1">
                  {
                    /* Prefix placement, matching Data Review and the table headers (AB#14859 AC 3).
                       Only attributes the SME marked custom get it — AC 5. */
                    attribute?.is_custom === true &&
                    <CustomAttributeTag data-testid={`attr-custom-tag-${attribute?.attr_name}`} />
                  }
                  {attribute?.attr_name ?? "---"}
                </Typography>
                <Typography variant="body-primary" as="span" className={`tw-block tw-mt-1 tw-text-ink-secondary`}>{varr?.toString()  ?? "---"}</Typography>
              </div>
            )})}
          </div>
          </React.Fragment>
  )
}

export default Attributes
